export const expenseMixin = {

	methods: {

		save(edit = false) {
			console.log(333333);
			if(!this.EX.firstValidation()) return

			let saveType = 'createExpenses'

			let data = this.EX.prepareSave(this.$store.getters.getUserProfile.id)

			if (edit) {
				saveType = 'updateExpenses'
				data = {
					data: data,
					id: this.EX.getId()
				}
			}

			this.$store.dispatch(saveType, data).then((response) => {
				if (!this._.has(response, 'data')) return this.openNotify('error', 'common_notificationUndefinedError')
				switch (this.getResponseStatus(response)) {
					/**
					 * Success
					 */
					case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {

						if(this.EX.data.Files.getFiles().length > 0){
							this.addFile(this.getRespData(response)?.id, edit)
							this.$router.push(this.$store.getters.GET_PATHS.expenses)
							return
						}

						if (edit) {
							this.openNotify('success', 'common_notificationRecordChanged')
						} else {
							this.openNotify('success', 'common_notificationRecordCreated')
						}
						this.$router.push(this.$store.getters.GET_PATHS.expenses)
						break
					}
					/**
					 * Validation Error
					 */
					case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
						let errors = response.response.data.errors;
						this.notifyErrorHelper(errors)
						break
					}
					/**
					 * Undefined Error
					 */
					default: {
						this.openNotify('error', 'common_notificationUndefinedError')
					}
				}
			})
		},

		addFile(id, edit) {
			if(id){
				let data = this.EX.prepareFileData(id)

				this.$store.dispatch('uploadFileExpenses', data).then(response => {
					if (!this._.has(response, 'data')) return this.openNotify('error', 'common_notificationUndefinedError')
					switch (this.getResponseStatus(response)) {
						/**
						 * Success
						 */
						case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
							if (edit) {
								this.openNotify('success', 'common_notificationRecordChanged')
							} else {
								this.openNotify('success', 'common_notificationRecordCreated')
							}
							break
						}
						/**
						 * Validation Error
						 */
						case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
							let errors = response.response.data.errors;
							this.notifyErrorHelper(errors)
							break
						}
						/**
						 * Undefined Error
						 */
						default: {
							this.openNotify('error', 'common_notificationUndefinedError')
						}
					}
				})
			}
		},

		getFileFromServer(file){
			this.$store.dispatch('getFileFromServer', file.id)
				.then((response) => {
					let dataFile = response
					let fileBase64 = dataFile
					Object.keys(dataFile).map(item => {
						dataFile[item] = {
							id: item,
							type: file.mime_type,
							uuid: file.uuid,
							base64: fileBase64[item]
						}
					})
					this.EX.data.Files.pushDownloadFiles(dataFile)
				})
		},

		getFileFromServerReturnObject(file, type = null){
			if(!file) return

			let localItem = file

			return this.$store.dispatch('getFileFromServer', file.id)
				.then((response) => {
					console.log(response);
					let fileBase64 = response
					switch (type) {
						case 'image':
							localItem.typeBase64 = `image`
							localItem.base64 = fileBase64[file.id]
							break
						default:
							localItem.base64 = fileBase64[file.id]
							break
					}

					return localItem
				})

		},
	}
}
